import React from 'react';

export class AuthHeader
{
    id:string = "";
    sessionGuid:string = "";
}